<template>
<div
  :style="sidebarStyle"
>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</div>
</template>
<script>
  export default {
    data(){
      return{
        backgroundImage: 'img/tsehaybank_screensaver-02.png'
      }
    },
    computed: {
      sidebarStyle () {
        return {
          // backgroundImage: `url(${this.backgroundImage})`
        }
      }
    }
  }
</script>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .1s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }

  /* Content wrapper to prevent footer overlap */
  .content-wrapper {
    min-height: calc(100vh - 200px);
    padding-bottom: 100px;
  }

  /* Ensure all page content has proper bottom margin */
  > div {
    padding-bottom: 80px;
  }
</style>
